<template>
<div class="shop-info">
  <el-dialog title="店铺信息" :visible.sync="dialogVisible" :modal-append-to-body='false' width="1200px" :before-close="handleClose">
    <div class="main scroll-auto">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="first">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="店铺名称：">
                <p>{{ form.name }}</p>
              </el-form-item>
              <el-form-item label="店铺logo：">
                <el-upload v-if="edit" action="#" list-type="picture-card" :auto-upload="false" :file-list="form.file" :class="form.file.length == 1 ? 'mf' : ''" :on-change="(file, fileList) => handleChange(file, fileList, 0)" :on-remove="(file, fileList) => handleRemove(file, fileList, 0)">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-image v-else style="width: 140px; height: 140px" :src="form.logo" fit="fill"></el-image>
              </el-form-item>
              <el-form-item label="运营联系人：">
                <p v-if="!edit">{{ form.operator_name }}</p>
                <el-input v-else v-model="form.operator_name" style="width: 340px" clearable placeholder="请输入运营联系人"></el-input>
              </el-form-item>
              <el-form-item label="联系人电话：">
                <p v-if="!edit">{{ form.operator_cellphone }}</p>
                <el-input v-else v-model="form.operator_cellphone" style="width: 340px" clearable placeholder="请输入联系人电话"></el-input>
              </el-form-item>
              <el-form-item label="店铺状态：">
                <p>{{ statusStr[Number(form.status)] }}</p>

              </el-form-item>
              <el-form-item v-show="edit">
                <el-button type="primary" size="small" @click="editShopInfo">提 交</el-button>
                <el-button size="small" @click="edit = false">取 消</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="收款账户" name="second">
            <el-form ref="form" :model="formPay" label-width="140px">
              <!--  <div class="subtitle">
                                    <h4>收款账户1</h4>
                                    <p>APP端收款时必须开通以下两项</p>
                                </div>
                                <el-form-item label="微信收款账户：">
                                    <el-button type="primary" size="small" @click="showWeChat">{{
                                        wx_status == 0 ? "审核拒绝，查看" : wx_status == 1 ? "审核中，查看" : wx_status == 3 ? "已开通，查看" : "去申请"
                                    }}</el-button>
                                </el-form-item>
                                <el-form-item label="支付宝收款账户：">
                                    <el-button type="primary" size="small" @click="showAlipay">{{
                                        ali_status == 0 ? "审核拒绝，查看" : ali_status == 1 ? "审核中，查看" : ali_status == 3 ? "已开通，查看" : "去申请"
                                    }}</el-button>
                                </el-form-item> -->
              <div class="subtitle">
                <h4>收款账户</h4>
              </div>
              <!-- :disabled="getIsAllinUser > 0" -->
              <el-form-item label="通联账户：">
                <el-button type="primary" size="small" @click="openUrl">{{ getIsAllinUser == 0 ? "去开通" : "已开通" }}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="品牌管理" name="third">
            <el-table :data="brandTable" style="width: 100%" border>
              <el-table-column align="center" prop="brand_name" show-overflow-tooltip label="品牌名称" width="180"> </el-table-column>
              <el-table-column align="center" prop="trademark_name" show-overflow-tooltip label="商标名称" width="180"> </el-table-column>
              <el-table-column align="center" prop="trademark_code" show-overflow-tooltip label="注册/申请号"> </el-table-column>
              <el-table-column align="center" prop="valid_end_date" label="到期时间"> </el-table-column>
              <el-table-column align="center" prop="trademark_lce" label="商标证">
                <template slot-scope="{ row }">
                  <el-image style="width: 60px; height: 60px" v-if="row.trademark_lce" :src="row.trademark_lce" :preview-src-list="[row.trademark_lce]"> </el-image>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="authorization" label="品牌授权书">
                <template slot-scope="{ row }">
                  <el-image style="width: 60px; height: 60px" v-if="row.authorization" :src="row.authorization" :preview-src-list="[row.authorization]"> </el-image>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!--  <el-tab-pane label="店铺资金管理" name="fouth">
                            <div class="deposit-dialog">
                                <div>信用额度：{{current_credit_limit}}元</div>
                                <div><span>商品保证金可用金额：{{deposit}}元</span>
                                <el-button type="primary" size="small" v-show="pay_deposit_amount >0"  @click="showPayDepositDialog">补交{{pay_deposit_amount}}元</el-button>
                                </div>
                                <div><span>零钱包：{{deposit_expand}}元</span>
                                <el-button type="primary" size="small" @click="showPayRechargeDialog">充值</el-button>
                                </div>
                            </div>
                        </el-tab-pane> -->
          <el-tab-pane label="商品标准名称管理" name="five">
            <div v-if="viewDetail==true">
              <addStrand @backFn="backFn" :shop_id="id" ref="addStrands" :typeId="typeId" :editData="editData" @successFn="successFn"></addStrand>
            </div>
            <div v-else>
              <standTable ref="standTables" :shopId="id" @editShow="editShow"></standTable>
            </div>
            <!-- <div class="sub">
                                <h3>经营类目</h3>
                                <div class="btn">
                                    <el-button type="info" size="small" plain @click="viewHistory(id)">申请记录</el-button>
                                    <el-button type="primary" size="small" @click="addCategory">新增类目</el-button>
                                </div>
                            </div> -->
            <!--    <el-table :data="classTable" style="width: 100%" border>
                                <el-table-column align="center" prop="level[0].top_name" show-overflow-tooltip label="一级类目"> </el-table-column>
                                <el-table-column align="center" prop="level[0].parent_name" show-overflow-tooltip label="二级类目"> </el-table-column>
                                <el-table-column align="center" prop="level[0].name" show-overflow-tooltip label="三级类目"> </el-table-column>
                                <el-table-column align="center" prop="level[0].deposit" label="类目押金 (元)"> </el-table-column>
                                <el-table-column align="center" prop="amount" label="类目押金余额 (元)"> </el-table-column>
                                <el-table-column align="center" prop="status" label="类目状态">
                                    <template slot-scope="{ row }">
                                        {{ row.status == 2 ? "冻结" : "正常" }}
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="audit_time" label="审核时间" show-overflow-tooltip> </el-table-column>
                                <el-table-column align="center" prop="address" label="操作">
                                    <template slot-scope="{ row }">
                                        <div class="link">
                                            <el-link type="primary" v-if="row.status == 2" @click="payShow(row)">解冻</el-link>
                                            <span v-else>-</span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table> -->
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="postition-btn" v-show="activeName == 'first'">
        <el-button size="small" type="info" plain @click="edit = true">修改信息</el-button>
        <!-- <el-button size="small" type="primary">关店申请</el-button> -->
      </div>
      <div class="postition-btn" v-show="activeName == 'five'">
        <el-button size="small" type="primary" @click="addTalent">添 加</el-button>

        <!-- <el-button size="small" type="primary">关店申请</el-button> -->
      </div>
    </div>
  </el-dialog>
  <el-dialog title="充值" :visible.sync="payRechargeDialog" :close-on-press-escape=false>

    <el-form>
      <el-form-item label="充值金额" v-show="edit_recharge_val == 1">
        <el-input v-model="recharge_val" style="width: 340px" clearable></el-input>
        <el-button type="primary" size="small" @click="amountSubmit(1)">确定</el-button>
      </el-form-item>
      <el-form-item label="充值金额" v-show="edit_recharge_val == 2">
        <span>{{recharge_val}}</span>
        <el-button type="primary" size="small" @click="amountSubmit(2)">编辑</el-button>
      </el-form-item>
      <el-form-item label="选择支付方式：">
        <template>
          <el-radio v-model="pay_type" label="offline" @change="changePayType()">线下支付</el-radio>
          <el-radio v-model="pay_type" label="online" @change="changePayType()">线上支付</el-radio>

        </template>
      </el-form-item>

      <el-card class="box-card pay-box-card" v-show=" pay_type == 'online'">
        <div>金额 :￥{{recharge_val}}</div>
        <template>
          <el-radio v-model="code_type" label="WeChat" @change="changeCodeType()">微信</el-radio>
          <el-radio v-model="code_type" label="AliPay" @change="changeCodeType()">支付宝</el-radio>
        </template>
        <div>请扫码支付</div>
        <div id="pay_qrcode"></div>
        <el-button @click="donePay(1)">已完成支付</el-button>
      </el-card>
      <el-card class="box-card pay-box-card" v-show=" pay_type == 'offline'">

        <div>金额 :￥{{recharge_val}}</div>
        <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" :on-success="handleUploadSuccess" :show-file-list="false">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">格式：PNG、PDF、JPG请上传支付凭证</div>
        </el-upload>

        <div>请在打款的时候备注【****店铺名称+保证金】</div>
        <div>
          汇法的开户账户信息：<br />
          银行账号：233454255666<br />
          银行名称：民生银行 <br />
          支行名称：杨浦-支行民生银行<br />
        </div>
        <el-button @click="donePay(2)">提交</el-button>
      </el-card>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import standTable from './strandTable'
import {
  mapGetters,
  mapActions
} from "vuex";
import {
  Loading
} from 'element-ui';
import QRCode from "qrcodejs2";
import addStrand from './strandAdd'
export default {
  data() {
    return {
      activeName: "first",
      dialogVisible: false,
      viewDetail: false,
      form: {
        file: [],
        logo: "",
        name: "",
        type: "",
        operator_cellphone: "",
        operator_name: "",
        status: "",
      },
      formPay: {},
      classTable: [],
      brandTable: [],
      id: "",
      shopType: ["官方店", "舰旗店", "专卖店", "专营店"],
      statusStr: ["被封禁/审核中初始状态", "正常", "注销审核中", "已注销"],
      edit: false,
      type: "",
      ali_status: "",
      wx_status: "",

      pay_deposit_amount: 0,
      current_credit_limit: 0,
      deposit_expand: 0,
      deposit: 0,
      can_recharge: 0,
      recharge_val: 0,
      edit_recharge_val: 1,
      payRechargeDialog: false,
      pay_type: "offline",
      code_type: 'WeChat',
      myloading: {},
      imageUrl: "",
      typeId:1,
      editData:''
    };
  },
  components: {
    standTable,
    addStrand
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
      getIsAllinUser: "getIsAllinUser",
      getRegisterUrl: "getRegisterUrl",
    }),
  },
  created() {
    this.getInfo();
  },
  methods: {
    ...mapActions({
      shopInfo: "detect/shopInfo",
      applylist: "detect/applylist", //店铺申请详情
      categoryMessage: "detect/categoryMessage", //店铺申请详情
      shopInfoUpdate: "detect/shopInfoUpdate",
      uploadFile: "commodity/uploadFile", //  图片上传
      resultInfo: "detect/resultInfo",
      getShopDepositInfo: "commodity/getShopDepositInfo", //  图片上传
      payDepositOffline: "commodity/payDepositOffline",
      payDepositOrder: "commodity/payDepositOrder",
      payDepositCheck: "commodity/payDepositCheck",
    }),
    addTalent() {
      this.viewDetail = true
      this.typeId = 1
      this.$nextTick(el=>{
        this.$refs.addStrands.item = {}

      })
    },
    getInfo() {
      this.resultInfo({
        token: this.getToken
      }).then(({
        data
      }) => {
        if (data.code == 1) {
          this.ali_status = data.data.ali_status;

          this.wx_status = data.data.wx_status;
          console.log(data, 'data---')
        }
      });
    },
    openUrl() {
      window.open(this.getRegisterUrl);
    },
    showWeChat() {
      this.$emit("showWeChat", this.wx_status);
    },
    showAlipay() {
      this.$emit("showAlipay", this.ali_status);
    },
    payShow(row) {
      this.$emit("payShow", row);
    },
    addCategory() {
      this.$emit("addCategory");
    },
    viewHistory(id) {
      this.$emit("viewHistory", id);
    },
    showShopDepositInfo() {
      let params = {
        token: this.getToken,
        shop_id: this.id,
      };
      this.getShopDepositInfo(params).then(({
        data
      }) => {
        if (data.code == 1) {
          this.pay_deposit_amount = data.data.pay_deposit_amount;
          this.current_credit_limit = data.data.current_credit_limit;
          this.deposit_expand = data.data.deposit_expand;
          this.deposit = data.data.deposit;
          this.can_recharge = data.data.can_recharge;
        } else {
          this.$message.error(data.msg);
        }
      });
    },

    showPayRechargeDialog(row) {
      this.recharge_val = 0;
      this.payRechargeDialog = true;
    },
    //点击金额确定，线上生成二维码，线下展示面板内容
    amountSubmit() {

      if (parseInt(this.recharge_val) > 0) {
        if (this.edit_recharge_val == 1) {
          this.edit_recharge_val = 2;
        } else {
          this.edit_recharge_val = 1;
        }
      } else {
        this.$message.error('金额不正确');
        return;
      }

      if (this.pay_type == 'online') {
        let params = {
          token: this.getToken,
          shop_id: this.id,
          code_type: this.code_type,
          is_recharge: 1,
          amount: this.recharge_val,
        };
        this.myloading = Loading.service({
          fullscreen: true
        });
        this.payDepositOrder(params).then((res) => {
          let pay_qrcode = document.getElementById("pay_qrcode");
          pay_qrcode.innerHTML = '';
          if (res.code == 1) {
            let qrcode_url = res.data;
            new QRCode("pay_qrcode", {
              width: 246,
              height: 246,
              text: qrcode_url,
            });
            this.myloading.close();
          } else {
            this.$message.error(res.msg);
            this.myloading.close();
          }
        });
      }
    },
    //切换支付方式
    changePayType() {

    },
    //切换支付渠道
    changeCodeType() {
      let params = {
        code_type: this.code_type,
        token: this.getToken,
        shop_id: this.id,
        is_recharge: 1,
        amount: this.recharge_val,
      };
      this.myloading = Loading.service({
        fullscreen: true
      });
      this.payDepositOrder(params).then((res) => {
        let pay_qrcode = document.getElementById("pay_qrcode");
        pay_qrcode.innerHTML = '';
        if (res.code == 1) {
          let qrcode_url = res.data;
          new QRCode("pay_qrcode", {
            width: 246,
            height: 246,
            text: qrcode_url,
          });
          this.myloading.close();
        } else {
          this.$message.error(res.msg);
          this.myloading.close();
        }
      });
    },
    //押金线下支付凭证上传
    handleUploadSuccess(res, file) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.myloading = Loading.service({
        fullscreen: true
      });
      this.uploadFile(formdata).then((response) => {
        if (response.code == 1) {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          this.imageUrl = response.data.formdata_details[0].urls;
          this.myloading.close();
        } else {
          this.$message({
            type: "warning",
            message: response.msg,
          });
          this.myloading.close();
        }
      });
    },
    donePay(type) {
      let params = {
        token: this.getToken,
        shop_id: this.id,
        is_recharge: 1,
        amount: this.recharge_val,
      };
      if (type == 1) {
        this.payRechargeDialog = false;
      } else if (type == 2) {
        params.offline_file = this.imageUrl;
        this.payDepositOffline(params).then((res) => {
          if (res.code == 1) {
            if (res.data.result) {
              this.payRechargeDialog = false;
              this.$message({
                message: '操作成功',
              });
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    editShopInfo() {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.operator_cellphone)) {
        return this.$message.warning("输入的手机号码有误");
      }
      let params = {
        token: this.getToken,
        shop_id: this.id,
        users_mains_id: this.$getSessionStorage("userid"),
        log: this.form.logo,
        operator_cellphone: this.form.operator_cellphone,
        operator_name: this.form.operator_name,
      };
      this.shopInfoUpdate(params).then(({
        data
      }) => {
        if (data.code == 1) {
          this.edit = false;
          this.$message.success("修改成功！");
          this.getShopInfo();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getBrandList() {
      console.log(this.id, 'this.id-----------')
      let params = {
        token: this.getToken,
        shop_id: this.id,
      };
      this.applylist(params).then(({
        data
      }) => {
        if (data.code == 1) {
          this.brandTable = data.data.brand;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getShopInfo() {
      let params = {
        token: this.getToken,
        shop_id: this.id,
        users_mains_id: this.$getSessionStorage("userid"),
      };
      this.shopInfo(params).then(({
        data
      }) => {
        if (data.code == 1) {

          let {
            logo,
            name,
            type,
            status
          } = data.data.shop;
          let {
            operator_cellphone,
            operator_name
          } = data.data.user;
          this.type = type;
          this.form = {
            logo,
            name,
            type: [this.shopType - 1],
            operator_cellphone,
            operator_name,
            status,
            file: [{
              url: logo,
              name: logo
            }],
          };
          console.log(this.form.status, 'data.data.shop----')
        }
      });
    },
    backFn() {
      this.viewDetail = false
      this.$nextTick(() => {
        this.$refs.standTables.getstrandList(this.id)
      })
    },
    successFn(){
  this.viewDetail = false
    this.$message.success('提交成功')
    this.$nextTick(() => {
        this.$refs.standTables.getstrandList(this.id)
      })
    },
    editShow(data) {
      this.typeId =2
      this.viewDetail = true
      this.editData =data
      console.log(data,'编辑------datya', this.typeId)
      
    },

    handleClick() {
      this.edit = false;
      switch (this.activeName) {
        case "first":
          this.getShopInfo();
          break;
        case "second":
          break;
        case "third":
          this.getBrandList();
          break;
        case "fourth":
          this.showShopDepositInfo();
          break;
        case "five":
          this.viewDetail = false
 
            this.$nextTick(() => {
              this.$refs.standTables.shop_id = this.id
              this.$refs.standTables.getstrandList(this.id)
              this.$refs.standTables.merageInit()
              // this.$refs.standTables.viewDetail = true
            })
       

          break;
        default:
          break;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.activeName = "first";
    },

    //文件上传
    handleChange(file, fileList, index) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      switch (index) {
        case 0:
          this.form.file = fileList;
          break;
        default:
          break;
      }
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功！");
          switch (index) {
            case 0:
              this.form.logo = res.data.formdata_details[0].urls;
              break;
            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //文件删除
    handleRemove(file, fileList, index) {
      switch (index) {
        case 0:
          this.form.file = [];
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-info {
  .main {
    height: 540px;
    position: relative;

    .subtitle {
      display: flex;
      align-items: center;
      margin-bottom: 22px;

      h4 {
        font-size: 16px;
        padding-left: 20px;
        line-height: 18px;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 2px;
          background: #2448ff;
        }
      }

      p {
        display: inline-block;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-left: 40px;

        span {
          color: #2448ff;
        }
      }
    }

    .sub {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    .postition-btn {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #ddd;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-tabs__content {
  padding: 20px;
}

::v-deep .el-table--border th.el-table__cell {
  background-color: #f8f9fe;
}

.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
</style><style>
.deposit-dialog {
  line-height: 40px;
}

.pay-box-card {
  text-align: center;
  line-height: 40px;
}

#pay_qrcode {
  width: 250px;
  margin-left: auto;
  margin-right: auto;
}

/**线下支付样式
 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
